import { Typography, Box, Container, Paper, AlertTitle, Alert } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import AcornBanner from '@acorn-portal/shared/src/components/banner/AcornLanderBanner';
import { formatCurrency } from '@acorn-portal/shared/src/utils/formatter';
import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';
import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import extractBeforeDash from '@acorn-portal/shared/src/utils/extractBeforeDash';
import MotorcadeLanderBanner from '@acorn-portal/shared/src/components/banner/MotorcadeLanderBanner';
import CarrotLanderBanner from '@acorn-portal/shared/src/components/banner/CarrotLanderBanner';
import SignupCallToAction from '@acorn-portal/shared/src/pages/payNow/components/sign-up-call-to-action';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { PayNowStatus } from '@acorn-portal/shared/src/services/api';
import FlagLanderBanner from '@acorn-portal/shared/src/components/banner/FlagLanderBanner';
import StreetCoverBanner from '../../../../StreetCover/src/components/banner/StreetCoverBanner';

interface IState {
	amount: number;
}

type LocationProps = {
	state: {
		amount: number;
	};
};

const company = extractBeforeDash(import.meta.env.VITE_JOURNEY || '');

const LandingBanner = () => {
	switch (company) {
		case 'MOTORCADE':
			return <MotorcadeLanderBanner text='Thank you for your payment!' />;
		case 'CARROT':
			return <CarrotLanderBanner text='Thank you for your payment!' />;
		case 'FLAG':
			return <FlagLanderBanner text='Thank you for your payment!' />;
		case 'STREETCOVER':
			return <StreetCoverBanner text='Thank you for your payment!' />;
		default:
			return <AcornBanner text='Thank you for your payment!' />;
	}
};

const DirectPaymentConfirmation: FC = () => {
	const navigate = useNavigate();
	const state = useAppSelector((redux) => redux.payNow);
	const location = useLocation() as unknown as LocationProps;
	const [locationState, setLocationState] = useState<IState | undefined>();

	useEffect(() => {
		if (location.state?.amount && location.state?.amount <= 0) {
			navigate(ROUTE_PATHS.home, { replace: true });
			return;
		}
		if (location.state?.amount) {
			setLocationState({
				amount: location.state?.amount,
			});
		}
	}, [location.state]);

	const debtCollectionPayment = false;

	const isConsolidatedPaymentSchedule = state.details?.status === PayNowStatus.ConsolidatedPaymentSchedule;

	return (
		<Paper
			elevation={1}
			sx={{
				margin: 1.5,
				borderRadius: '8px',
				paddingBottom: 3,
			}}
		>
			<div>
				<LandingBanner />
				<Container maxWidth='sm' sx={{ textAlign: 'center' }}>
					<Box my={4}>
						<Alert
							icon={<CheckCircleOutlineIcon sx={{ height: '30px' }} />}
							severity='success'
							sx={(theme) => ({
								width: '100%',
								borderRadius: '4px',
								textAlign: 'center',
								pt: 2,
								alignContent: 'center',
								border: `1px solid ${theme.palette.success.main}`,
							})}
						>
							{locationState?.amount ? (
								<AlertTitle sx={{ fontSize: 20, color: 'success.dark' }}>
									{' '}
									Your payment of {locationState?.amount ? formatCurrency(locationState?.amount) : ''} has been taken.
								</AlertTitle>
							) : (
								<AlertTitle sx={{ fontSize: 20, color: 'success.dark' }}> Your payment has been taken.</AlertTitle>
							)}
						</Alert>

						<br />
						{debtCollectionPayment === false && (
							<>
								<Typography align='left' marginBottom={2}>
									Your policy payments are now up to date. Please rest assured that your cover will now continue as
									normal.
								</Typography>
								{!isConsolidatedPaymentSchedule && (
									<Typography align='left'>
										If you have entered into a payment plan with us, to pay this outstanding payment. We will take out
										the next payment on the agreed day.
									</Typography>
								)}
							</>
						)}
						<Typography align='left' sx={{ fontWeight: 600, marginTop: 2 }}>
							A receipt for this transaction has been sent via email for your records.
						</Typography>
						<Box sx={{ mt: 3 }} />
						{!isConsolidatedPaymentSchedule && <SignupCallToAction />}
					</Box>
				</Container>
			</div>
		</Paper>
	);
};

export default DirectPaymentConfirmation;
